
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M12 4a8 8 0 110 16 8 8 0 010-16zm.6 3.2c-1.427 0-2.6 1.117-2.6 2.514L9.999 12H9.6l-.144.013A.8.8 0 009.6 13.6h.399L10 14.857l-.014.088a.377.377 0 01-.277.242L9.6 15.2l-.168.014c-.843.15-.843 1.422 0 1.572l.168.014h4.8l.144-.013A.8.8 0 0015.2 16l-.013-.144a.8.8 0 00-.787-.656h-2.834l.024-.143a1.92 1.92 0 00.01-.2l-.001-1.257H12.8l.144-.013A.8.8 0 0012.8 12h-1.201l.001-2.286.013-.146c.076-.43.482-.768.987-.768.56 0 1 .418 1 .914l.013.144a.8.8 0 001.587-.144c0-1.397-1.173-2.514-2.6-2.514z"}})])
          )
        }
      }
    